import { render, staticRenderFns } from "./slide-modal.vue?vue&type=template&id=32cb191f&scoped=true&"
import script from "./slide-modal.vue?vue&type=script&lang=js&"
export * from "./slide-modal.vue?vue&type=script&lang=js&"
import style0 from "./slide-modal.vue?vue&type=style&index=0&id=32cb191f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cb191f",
  null
  
)

export default component.exports